export function handleToNumber({ value, digits = 0 }) {
  // 是否要求整数
  let requireInteger = digits === 0
  // 把不是数字或小数点的字符去掉
  let result = value.replace(requireInteger ? /[^0-9]/g : /[^0-9.]/g, '')
  // 去掉开头的小数点
  result = result.replace(/^\./g, '')
  // 如果开头字符是 '0',第二个字符不是 '.',则去掉第一个 '0'
  result = result.replace(requireInteger ? /^0./ : /^0[^.]/, match =>
    match.charAt(1)
  )
  // 去掉相连小数点的第二个小数点
  result = result.replace(/\.{2,}/g, '.')
  /* 去掉第二次出现的小数点，并且确定第二个小数点后面的位数 */
  let numbers = result.split('.')
  if (numbers.length > 1) {
    result = `${numbers[0]}.${numbers[1].substr(0, digits)}`
  }
  return result
}
